import { createSlice } from '@reduxjs/toolkit';
import { m } from '../../../utils/date';

const initialState = {
    data: [],
    page: {
        page: 1,
        size: 10,
        totalPage: 1,
        totalSize: 2,
    }
};

const productOutSlice = createSlice({
    name: 'productOut',
    initialState,
    reducers: {
        funGetProductOut(state, action){
            const { list, page, size, totalPage, totalSize } = action.payload;
            state.data = list.map(( productOut ) => {
                return{
                    ...productOut,
                    forwardingDt: m.date({ value: productOut.forwardingDt }),
                }
            });
            state.page = { page, size, totalPage, totalSize };
        }
    },
});

export const productOutActions = productOutSlice.actions;
export default productOutSlice.reducer;